import React, { useEffect } from 'react';
import ButtonSeatUpgrade from './ButtonSeatUpgrade';
import ButtonUpgrade from './ButtonUpgrade';
import ButtonTeam from './ButtonTeam';
import ButtonUsers from './ButtonUsers';

import { useActionsQueryLazyQuery } from './Actions.generated';

const ButtonUser = () => {
  const [fetch, { loading, data }] = useActionsQueryLazyQuery();
  useEffect(() => {
    fetch();
  }, []);

  if (loading) return null;
  if (!data?.user) return null;
  const user = data?.user;

  const { team } = user;
  const teamMembership = user.teamMembership ?? {
    isAdmin: false,
    memberType: '',
  };
  const { isAnnual } = user.package ?? {};
  const canAddUsers =
    teamMembership.isAdmin && team && team.ssoState !== 'REQUIRED';
  const showSeatUpgradeButton =
    user?.features?.powerCasualEnabled &&
    teamMembership.memberType === 'CASUAL';

  if (showSeatUpgradeButton) {
    return <ButtonSeatUpgrade />;
  }
  if (canAddUsers) {
    return <ButtonUsers />;
  }
  if (!team && isAnnual) {
    return <ButtonTeam />;
  }
  if (!team) {
    return <ButtonUpgrade />;
  }
  return null;
};

export default ButtonUser;
